<template>
  <div class="index" id="anchor">
    <Seacher></Seacher>
    <div class="tranbox">
      <div class="tranboxtit">Accounts</div>
      <div class="indexbox">
        <div class="iboxleft">
          <div class="iboxtit">Number of Accounts</div>
          <div class="iboxcon">2,588,555</div>
          <div class="iboxbottom">
            <div class="ibttol">+256</div>
            <div class="ibttor">Last 24h</div>
          </div>
        </div>
      </div>
      <div class="indexbox">
        <div class="iboxleft">
          <div class="iboxtit">Daily Active Accounts</div>
          <div class="iboxcon">989,898</div>
          <div class="iboxbottom">
            <div class="ibttol">+5.55%</div>
            <div class="ibttor">24h Change</div>
          </div>
        </div>
      </div>
      <div class="trancharts">
        <div class="charts_tit">
          <div class="charts_l">Total Account & Active Account</div>
          <div class="charts_btn">
            <span> More</span> <img src="../../assets/m/home/more.png" />
          </div>
        </div>
        <div class="charts">
          <div
            id="charts"
            ref="chart"
            style="width: 356px; height: 350px"
          ></div>
        </div>
      </div>
    </div>
    <!-- translist start -->
    <div class="translist">
      <div class="Block_Top notranslate">
        <span class="notranslate"
          >Accounts</span
        >
      </div>
      <div class="resume-list">
        <div class="pool_main">
          <div class="tags">
            <div class="indexList">
              <div class="Block_list">
                <ul class="block_list_Top">
                  <li>#</li>
                  <li>Address</li>
                  <li>Balance</li>
                  <li>Percentage</li>
                  <li>Txn Count</li>
                  <li>Latest Txn Time</li>
                  <!-- <li>Amount</li> -->
                </ul>
              </div>
              <div class="Block_List_center notranslate">
                <ul>
                  <li v-for="index of 14" :key="index">
                    <p>1</p>
                    <p>ASsdS...ERdffc</p>
                    <p>0.2555 TTOS</p>
                    <p>70%</p>
                    <p>1</p>
                    <p>53 minutes 28 seconds ago</p>
                    <!-- <p>234234 TTOS</p> -->
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="block">
          <el-pagination
            background
            small
            :current-page.sync="pageNum"
            :page-size="10"
            :pager-count="5"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- translist end -->
    <!-- <div class="list">
      <div class="list-data">
        <div class="head">Transactions</div>
        <div class="list-height">
          <div
            class="content_center"
            v-for="(transfer, index) in transferList"
            :key="index"
          >
            <div>
              Txn Hash<span
                class="notranslate"
                @click="goDetail('hash', transfer.txHash)"
                >{{ transfer.txHash }}</span
              >
            </div>
            <div>
              Type<span
                class="black notranslate"
                @click="goDetail('height', 1)"
                >{{ transfer.type }}</span
              >
            </div>
            <div>
              Age<span class="black notranslate"
                >{{ transfer.tradeTime }}
              </span>
            </div>
            <div
              v-if="
                transfer.type == 'Unstake' || transfer.fromAddress == 'Unpledge'
              "
            >
              From<span class="black notranslate">Unstake</span>
            </div>
            <div v-if="transfer.type == 'Bonus'">
              From<span class="black notranslate">Bonus</span>
            </div>

            <div
              v-if="
                (transfer.type == 'Transfer' ||
                  transfer.type == 'Delegate' ||
                  transfer.type == 'Withdraw' ||
                  transfer.type == 'Signature Rewards' ||
                  transfer.type == 'Stake') &&
                transfer.fromAddress !== 'Unpledge'
              "
            >
              From<span
                class="notranslate"
                @click="goDetail('transfer', transfer.fromAddress)"
                >{{ transfer.fromAddress }}</span
              >
            </div>
            <div
              v-if="
                transfer.type == 'Transfer' ||
                transfer.type == 'Delegate' ||
                transfer.type == 'Withdraw' ||
                transfer.type == 'Unstake' ||
                transfer.type == 'Bonus'
              "
            >
              To
              <span
                class="notranslate"
                @click="goDetail('transfer', transfer.toAddress[0])"
                >{{
                  transfer.toAddress[0] == "Pledge"
                    ? "Stake"
                    : transfer.toAddress[0]
                }}</span
              >
            </div>
            <div v-if="transfer.type == 'Signature Rewards'">
              To
              <span class="black notranslate">Signature Rewards</span>
            </div>
            <div v-if="transfer.type == 'Stake'">
              To
              <span class="black notranslate">Stake</span>
            </div>

            <div>
              Amount<span class="black notranslate"
                >{{ transfer.amount }}TTOS</span
              >
            </div>
            <div>
              Gas<span class="black notranslate">{{ transfer.gas }} TTOS</span>
            </div>
          </div>
        </div>
        <div class="block">
          <el-pagination
            background
            small
            :current-page.sync="pageNum"
            :page-size="10"
            :pager-count="5"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
const echarts = require("echarts");
import Seacher from "@/components/m/Seacher.vue";
import { TradeList } from "../../assets/server/api.js";
import { formatSeconds, listTypea } from "../../utils/utils.js";
export default {
  components: {
    Seacher,
  },
  data() {
    return {
      pageSize: 1,
      total: null,
      pageNum: 1,
      pagerCount: 0,
      transferList: [],
    };
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  created() {
    this.pageNum = this.getContextData("tiaozhuan1") || 1;
  },
  mounted() {
    this.getTradeList();
    this.initCharts();
  },
  destroyed() {},
  methods: {
      initCharts() {
      this.lineChart = echarts.init(this.$refs.chart);
      let option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(36,41,49,0.8)", //设置背景图片 rgba格式
          color: "rgba(255, 255, 255, 0.5)",
          formatter: function (params) {
            let str =
              '<span style="color:#fff;font-size:12px;text-align:left;display:block;">' +
              params[0].name +
              "(UTC)" +
              "</span>" +
             
              "<div style='display:flex;'>" +
              "<span style=' width:6px;height:6px;margin-top:10px;margin-right:4px; border-radius:10px;display:block;background:#00E79A;'></span>" +
              "<span style='color:#fff'>Total Account :</span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
              params[0].value +
              "</span>" +
              "</div>"+
              "<div style='display:flex;'>" +
              "<span style=' width:6px;height:6px;margin-top:10px;margin-right:4px; border-radius:10px;display:block;background:#D3F85A;'></span>" +
              "<span style='color:#fff'>Active Account :</span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
              params[1].value +
              "</span>" +
              "</div>"
              ;
            return str;
          },
        },
        // legend: {
        //   data: ["Email", "Union Ads", "Video Ads", "Direct", "Search Engine"],
        // },
        grid: {
          top:"9%",
          left: "2%",
          right: "2%",
          bottom: "8%",
          containLabel: true,
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {},
        //   },
        // },
        xAxis: {
          type: "category",
          show: true,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          axisLine: {
            show: false, //隐藏x轴线
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false, //隐藏x轴刻度
          },
        },
        yAxis: {
          type: "value",
          show: true,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#00E79A",
                },
                {
                  offset: 0,
                  color: "#00E79A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#00E79A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: [820, 932, 901, 934, 1290, 1330, 1320],
          },
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#D3F85A",
                },
                {
                  offset: 0,
                  color: "#D3F85A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#D3F85A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: [82, 92, 91, 34, 190, 130, 120],
          },
        ],
      };
      this.lineChart.setOption(option);
    },
    // initCharts() {
    //   this.lineChart = echarts.init(this.$refs.chart);
    //   var data = [
    //     { value: 40, name: "Transfer" },
    //     { value: 38, name: "Staking/Unstaking" },
    //     { value: 32, name: "Delegation/Withdrawal" },
    //     { value: 30, name: "Claiming bonuses" },
    //     { value: 28, name: "Triggering  smart contracts" },
    //   ];
    //   let option = {
    //     tooltip: {
    //       // trigger: "item",
    //       backgroundColor: "rgba(36,41,49,0.9)", //设置背景图片 rgba格式
    //       color: "rgba(255, 255, 255, 0.5)",
    //       // borderWidth: "1", //边框宽度设置1
    //       // borderColor: "gray", //设置边框颜色
    //       formatter: function (params) {
    //         // console.log(params);
    //         // console.log(params[0].value);
    //         let str =
    //           '<span style="color:#fff;font-size:12px;">' +
    //           34 +
    //           "(UTC)" +
    //           "</span>" +
    //           "</br>" +
    //           "<span style='color:#fff'>Transactions:</span>" +
    //           '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
    //           "34wsew" +
    //           "</span>";
    //         return str;
    //       },
    //     },
    //     legend: {
    //       show: true,
    //       orient: "vertical",
    //       x: "5%", //可设定图例在左、右、居中
    //       y: "50%",
    //       icon: "circle",
    //       padding: [0, 50, 0, 0],
    //       itemHeight: 9, // 图例icon高度
    //       itemWidth: 9, // 图例icon宽度
    //       align: "left", // 图例icon在左侧
    //       itemGap: 20, // 图例每项之间的间隔。
    //       itemHeight: 14, //  图例标记的图形高度。
    //       formatter: function (name) {
    //         // 添加
    //         let total = 0;
    //         let target;
    //         for (let i = 0; i < data.length; i++) {
    //           total += data[i].value;
    //           if (data[i].name === name) {
    //             target = data[i].value;
    //           }
    //         }
    //         var arr = [
    //           "{a|" + name + "}",
    //           "{b|" + ((target / total) * 100).toFixed(2) + "%}",
    //         ];
    //         return arr.join("  ");
    //       },
    //       textStyle: {
    //         // 添加
    //         padding: [0, 0, 0, 0],
    //         rich: {
    //           a: {
    //             fontSize: 14,
    //             width: 182,
    //             color: "rgba(255,255,255,0.5)",
    //           },
    //           b: {
    //             fontSize: 14,
    //             width: 80,
    //             color: "#c1c1c1",
    //           },
    //           c: {
    //             fontSize: 14,
    //             color: "#fff",
    //             width: 80,
    //           },
    //         },
    //       },
    //     },

    //     color: ["#00C785", "#14C9C9", "#F7BA1E", "#722ED1", "#3491FA"],
    //     series: [
    //       {
    //         // name: "Access From",
    //         type: "pie",

    //         radius: ["15%", "45%"],
    //         center: ["26%", "26%"],

    //         roseType: "radius",
    //         itemStyle: {
    //           borderRadius: 5,
    //         },
    //         label: {
    //           show: false,
    //         },
    //         emphasis: {
    //           label: {
    //             show: true,
    //           },
    //         },
    //         avoidLabelOverlap: false,
    //         itemStyle: {
    //           // borderRadius: 10,
    //           // borderColor: "#fff",
    //           borderWidth: 2,
    //         },
    //         label: {
    //           show: false,
    //           position: "center",
    //         },
    //         emphasis: {
    //           label: {
    //             show: false,
    //             fontSize: "40",
    //             fontWeight: "bold",
    //           },
    //         },
    //         labelLine: {
    //           show: false,
    //         },
    //         data: data,
    //       },
    //     ],
    //   };
    //   this.lineChart.setOption(option);
    // },
    setContextData: function (key, value) {
      if (typeof value == "string") {
        sessionStorage.setItem(key, value);
      } else {
        sessionStorage.setItem(key, JSON.stringify(value));
      }
    },
    getContextData: function (key) {
      const str = sessionStorage.getItem(key);
      if (typeof str == "string") {
        try {
          return JSON.parse(str);
        } catch (e) {
          return str;
        }
      }
      return;
    },
    handleCurrentChange(currentPage) {
      this.pageNum = currentPage;
      document.querySelector("#anchor").scrollIntoView(true);
      this.setContextData("tiaozhuan1", this.pageNum);
      this.getTradeList();
    },
    async getTradeList() {
      let formData = new FormData();
      let params = {
        pageNum: this.pageNum,
        pageSize: 10,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await TradeList(formData);
      this.total = res.result.total;
      this.transferList = res.result.tradeList;
      for (var i = 0; i < this.transferList.length; i++) {
        this.transferList[i].toAddress =
          this.transferList[i].toAddress.split(",");
        var calctimea = new Date();
        let strdatea = Math.floor(calctimea.getTime() / 1000);
        let timestampa = Math.floor(
          this.gltimea(this.transferList[i].tradeTime) / 1000
        );
        var s = strdatea - timestampa;
        if (s <= 0) {
          s = 1;
        }
        this.transferList[i].tradeTime = formatSeconds(s);
        this.transferList[i].type = listTypea(this.transferList[i].type);
      }
    },
    goDetail(name, query) {
      switch (name) {
        case "hash":
          this.$router.push({
            path: "/m/TransferDetails",
            query: { txHash: query },
          });
          break;
        case "transfer":
          this.$router.push({
            path: "/m/Address",
            query: { address: query },
          });
          break;
        case "height":
          this.$router.push({
            path: "/m/BlockList",
            query: { id: query },
          });
          break;
      }
    },
    gltimea(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
  },
};
</script>
<style lang="less">
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #00a870;
  color: #fff;
  border: none;
}
.el-pager li {
  margin: 0px 6px !important;
  padding: 0px 6px !important;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev {
  background: #3c485c;
  color: #adb0c7;
  width: 10px !important;
}

.el-pagination.is-background .el-pager li {
  padding-left: 6px;
  padding-right: 6px;
  height: 48px;
  margin: 0 10px;
  background: #3c485c;
  border-radius: 8px;
  opacity: 1;

  font-size: 24px;
  font-family: SF Pro Text-Regular, SF Pro Text;
  font-weight: 400;
  color: #ffffff;
  line-height: 48px;

  text-align: center;
}
</style>

<style lang="less" scoped>
.el-pagination {
  padding-bottom: 32px !important;
}
.index {
  width: 750px;
  margin: 110px auto 0px auto;
  background: #13161b;
  text-align: center;
  .tranbox {
    width: 702px;
    height: 1307px;
    background: #000000;
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    margin: 0 auto;
    .tranboxtit {
      text-align: left;
      height: 42px;
      font-size: 30px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 42px;
      padding-top: 24px;
      margin-left: 24px;
      margin-bottom: 48px;
    }
    .indexbox {
      width: 654px;
      height: 208px;
      background: #13161b;
      border-radius: 24px 24px 24px 24px;
      opacity: 1;
      margin: 0 auto;
      display: flex;
      margin-bottom: 24px;
      justify-content: space-between;
      .iboxleft {
        margin-left: 24px;
        .iboxtit {
          margin-top: 24px;
          height: 34px;
          text-align: left;
          font-size: 24px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #8a8a8a;
          line-height: 34px;
        }
        .iboxcon {
          height: 62px;
          font-size: 44px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 62px;
          margin-bottom: 24px;
          margin-top: 2px;
          text-align: left;
        }
        .iboxbottom {
          display: flex;
          .ibttol {
            height: 34px;
            font-size: 24px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #00e79a;
            line-height: 34px;
          }
          .ibttor {
            margin-left: 16px;
            height: 34px;
            font-size: 24px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #8a8a8a;
            line-height: 34px;
          }
        }
      }
      .iboxright {
        margin-right: 24px;
        img {
          margin-top: 64px;
          width: 84px;
          height: 84px;
        }
      }
    }
    .trancharts {
      width: 654px;
      height: 729px;
      background: #13161b;
      border-radius: 16px 16px 16px 16px;
      opacity: 1;
      margin: 0 auto;
      .charts_tit {
        display: flex;
        justify-content: space-between;
        padding-top: 24px;
        .charts_l {
          margin-left: 24px;
          height: 42px;
          font-size: 30px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #8a8a8a;
          line-height: 42px;
        }
        .charts_btn {
          margin-right: 24px;
          width: 127px;
          height: 44px;
          background: #000000;
          border-radius: 13px 13px 13px 13px;
          opacity: 1;
          span {
            font-size: 24px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            margin-left: 20px;
          }
          img {
            width: 40px;
            height: 40px;
          }
        }
      }
    }
  }
  .translist {
    width: 100%;
    overflow: hidden;
    margin-top: 24px;
    background: #13161b;
    .Block_Top {
      text-align: left;
      width: 702px;
      height: 80px;
      line-height: 80px;
      margin: 0 auto;
      background: #0b0c0f;
      border-radius: 24px 24px 0 0;
      span {
        font-size: 30px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        margin-left: 24px;
      }
      b {
        margin-left: 10px;
      }
    }
    //轮播图片开始
    .resume-list {
      width: 702px;
      background: #0b0c0f;
      border-radius: 0 0 24px 24px;
      margin: 0 auto;
      .pool_main {
        width: 100%;
      }
      .tags {
        display: flex;
        overflow: auto;
        white-space: nowrap;
      }
      //隐藏滚动条
      .tags::-webkit-scrollbar {
        display: none;
      }
      // 列表开始
      .indexList {
        width: 100%;
        margin: 0;
        padding: 0;
        background: #0b0c0f;
        .Block_list {
          .block_list_Top {
            display: flex;
            width: 1600px;
            height: 82px;
            line-height: 82px;
            background: #13161b;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            li {
              font-size: 28px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              height: 82px;
              line-height: 82px;
              -webkit-background-clip: text;
              // flex: 0 0 14%;
              text-align: left;
            }
            li:nth-child(1) {
              // border: 1px solid red;
              margin-left: 24px;
              width: 100px;
            }
            li:nth-child(2) {
              width: 300px;
            }
            li:nth-child(3) {
              width: 300px;
            }
            li:nth-child(4) {
              width: 300px;
            }
            li:nth-child(5) {
              width: 200px;
            }
            li:nth-child(6) {
              width: 200px;
            }
            // li:nth-child(7) {
            //   width: 200px;
            // }
          }
        }
        .Block_List_center {
          width: 1600px;
          ul {
            //  height: 620px;
            width: 1600px;
            margin: 0;
            padding: 0;
            //padding: 0 19px;
            li {
              display: flex;
              height: 82px;
              border-bottom: 1px solid #22252e;
              line-height: 82px;
              margin-left: 24px;
              // width: 200px;
              p {
                font-size: 26px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                text-align: left;
                // flex: 0 0 14%;
              }
            }
            li:last-child {
              border-bottom: none;
            }
            p:nth-child(1) {
              width: 100px;
              color: #8a8a8a;
              // border: 1px solid red;
            }
            p:nth-child(2) {
              width: 300px;
            }
            p:nth-child(3) {
              width: 300px;
              color: #8a8a8a;
            }
            p:nth-child(4) {
              width: 300px;
              color: #8a8a8a;
            }
            p:nth-child(5) {
              width: 200px;
              color: #8a8a8a;
            }
            p:nth-child(6) {
              width: 200px;
              color: #8a8a8a;
            }
            // p:nth-child(7) {
            //   width: 200px;
            // }
          }
        }
      }
      .block {
        margin-top: 70px;
        padding-bottom: 70px;
        font-size: 28px;
        font-family: "PingFang SC-中黑体, PingFang SC";
        font-weight: normal;
        color: #adb0c7;
        // line-height: 39px;
      }
    }

    //轮播图片结束
  }
  .list {
    text-align: center;
    padding-bottom: 80px;
  }
  .list-data {
    margin: 30px auto 0px auto;
    width: 690px;
    min-height: 1197px;
    /*height: 1197px;*/
    /*height: 920px;*/
    background: #232a35;
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    .block {
      margin-top: 32px;
      padding-bottom: 70px;
      font-size: 28px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      color: #adb0c7;
      // line-height: 39px;
    }
  }

  .head {
    width: 690px;
    padding: 24px 12px;
    // margin:32px 0 32px 32px;
    background: #232a35;
    opacity: 1;
    border-radius: 16px 16px 16px 16px;
    padding-left: 30px;
    text-align: left;
    height: 48px;
    font-size: 32px;
    font-family: SF Pro Text-Medium, SF Pro Text;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    line-height: 48px;
    span {
      font-size: 26px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      color: #b2b7c2;
      line-height: 36px;
    }
  }
  .xian {
    border-bottom: none !important;
  }
  .list-height {
    min-height: 1197px;
    .content_center {
      text-align: left;
      padding: 40px 0px 40px 0px;
      font-size: 26px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      color: #adb0c7;
      line-height: 36px;
      border-bottom: 1px solid #3c485c;
      margin: 0px 32px;
      div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 16px;
        height: 44px;
        line-height: 44px;
        font-size: 28px;
        font-family: SF Pro Text-Medium, SF Pro Text;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.55);
      }
      span {
        padding-bottom: 10px;
        width: 447px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
        float: right;
        height: 44px;
        font-size: 28px;
        font-family: SF Pro Text-Regular, SF Pro Text;
        font-weight: 400;
        color: #00a870;
        padding-left: 32px;
        line-height: 44px;
      }
      .black {
        height: 44px;
        font-size: 28px;
        font-family: SF Pro Text-Regular, SF Pro Text;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.9);
        line-height: 44px;
        padding-left: 32px;
      }
      span:nth-child(4) {
        color: #2c3852 !important;
      }
      span:nth-child(5) {
        color: #2c3852 !important;
      }
      img {
        width: 48px;
        height: 48px;
        float: right;
        vertical-align: center !important;
      }
    }
  }
}
</style>
